import React from "react";
import ContentRecommendationBlock from "../ContentRecommendationBlock";
import { TabContent } from "../types";
import styles from "./index.style.module.css";

interface ContentQualityTabsProps {
  tabs: TabContent[];
  onToggle?: (id: string, selected: boolean) => void;
  className?: string;
}

const ContentQualityTabs: React.FC<ContentQualityTabsProps> = ({
  tabs,
  onToggle,
  className = "",
}) => {
  const handleToggle = (id: string, selected: boolean) => {
    if (onToggle) {
      onToggle(id, selected);
    }
  };

  const blocks = tabs[0]?.blocks || [];

  const visibleBlocks = blocks.filter((block) =>
    block.recommendations.some((rec) => rec.items.length > 0),
  );

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.tabContent}>
        {visibleBlocks.map((block) => (
          <ContentRecommendationBlock
            key={block.id}
            variant={block.variant}
            icon={block.icon}
            title={block.title}
            recommendations={block.recommendations}
            onToggle={handleToggle}
            className={styles.block}
          />
        ))}
      </div>
    </div>
  );
};

export default ContentQualityTabs;
